import { useState, forwardRef } from "react";
import { Button, Grid } from "@mui/material";
import { Typography } from "@mui/material";
import CardAnswer from "../../../components/shared/cardAnswer/CardAnswer";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

const CardQuestion = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      handlePayload,
      isEdit,
      latestStepQuestion,
    },
    ref
  ) => {
    const [myAnswer, setMyAnswer] = useState(null);
    const nextQuestionHandler = (height, value) => {
      setMyAnswer(value);
      handlePayload(data, value);
      scrollToQuestion(data, height, value);
    };
    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)");

    return (
      <div style={{ padding: isMobile ? "100px 0px" : "100px 20px" }} ref={ref}>
        <>
          <Typography variant="subtitle1">{t(data.question)}</Typography>
          {/* <br></br> */}
          <Grid container spacing={2}>
            {data.choises.map((choise, index) => (
              <Grid item xs={choise.xs} lg={choise.lg} key={`card${index}`}>
                <CardAnswer
                  title={t(choise.value)}
                  id={choise.id}
                  value={choise.value}
                  checked={choise.value === myAnswer}
                  nextQuestionHandler={(value) =>
                    nextQuestionHandler(ref.current.clientHeight, value)
                  }
                />
              </Grid>
            ))}
          </Grid>
          {currentQuestion === data.id &&
          currentQuestion !== latestQuestion &&
          !(isEdit && latestStepQuestion === data.id) ? (
            <>
              {" "}
              {/* <br></br> */}
              <Button
                onClick={(option) => {
                  nextQuestionHandler(ref.current.clientHeight, option);
                }}
                disabled={data.required}
                style={{ height: "50px", marginTop: "20px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <> </>
          )}
        </>
      </div>
    );
  }
);

export default CardQuestion;
